import type { JSX } from 'react';

import { Badge } from '../Badge/Badge';

import styles from './ReleaseItems.module.css';
import { tagLabel } from './releaseNoteFormat';

const INDICATOR = { new: 'green', imp: 'blue' } as const;

/** The items of one release: a tag, then the sentence. Shared by the panel and the full page. */
export function ReleaseItems({
  items,
  limit,
}: {
  items: { tag: string; text: string }[];
  /** Show only this many, with a "+N more" line for the rest. */
  limit?: number;
}): JSX.Element {
  const shown = limit === undefined ? items : items.slice(0, limit);
  const hidden = items.length - shown.length;
  return (
    <ul className={styles.Items}>
      {shown.map((item, index) => (
        <li key={`${index}:${item.tag}`} className={styles.Item}>
          <Badge
            size="small"
            indicator={INDICATOR[item.tag as keyof typeof INDICATOR]}
            badgeType={item.tag === 'fix' ? 'secondary' : undefined}
            className={styles.Tag}
          >
            {tagLabel(item.tag)}
          </Badge>
          <span className={limit === undefined ? styles.Text : styles.TextClamped}>
            {item.text}
          </span>
        </li>
      ))}
      {hidden > 0 && <li className={styles.More}>{`+${hidden} more`}</li>}
    </ul>
  );
}
